import { render, staticRenderFns } from "./drawer-battery-capacity-of-stand.vue?vue&type=template&id=64e90eba&"
import script from "./drawer-battery-capacity-of-stand.vue?vue&type=script&lang=js&"
export * from "./drawer-battery-capacity-of-stand.vue?vue&type=script&lang=js&"
import style0 from "./drawer-battery-capacity-of-stand.vue?vue&type=style&index=0&id=64e90eba&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports